import type { StudentTraits } from '@blueshift-ui/analytics/dist/types/student-traits';

function getStudentTraits(student: any): StudentTraits {
  return {
    email: student.email,
    enablements: student.enablements?.map((enablement: any) => enablement.product.short_name) ?? [],
    first_name: student.firstName,
    grade_id: student.grade,
    last_name: student.lastName,
    user_id: student.userId,
    uuid: student.uuid,
  };
}

export default getStudentTraits;
